'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { useUrlMultiSelect } from '../../_hooks/useUrlFilterController';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SearchSectionShell } from '../SearchSectionShell';
import { PolicyInfoFilter } from './PolicyInfoFilter';
import { PolicyInfoList } from './PolicyInfoList';
interface PolicyInfoSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
  isFilterOpen: boolean;
  onCloseFilter: () => void;
}
export function PolicyInfoSearch(t0) {
  const $ = _c(23);
  const {
    keyword,
    page,
    onPageChange,
    isFilterOpen,
    onCloseFilter
  } = t0;
  const tag = useUrlMultiSelect("guideTags");
  let t1;
  if ($[0] !== keyword || $[1] !== page || $[2] !== tag.values) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/best-contents"]({
      query: {
        searchKeyword: keyword,
        bestContentsTagIdList: tag.values.length > 0 ? tag.values : undefined,
        bestContentsSort: "LATEST",
        page,
        size: PAGE_SIZE
      }
    });
    $[0] = keyword;
    $[1] = page;
    $[2] = tag.values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData
    };
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount;
  let t4;
  if ($[6] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const meta = t4;
  let t5;
  if ($[8] !== isFilterOpen || $[9] !== onCloseFilter) {
    t5 = <PolicyInfoFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} />;
    $[8] = isFilterOpen;
    $[9] = onCloseFilter;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchSideAdBanner />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== data?.context?.contents || $[13] !== isLoading) {
    t7 = isLoading ? <SearchContentsCardSkeletonList count={PAGE_SIZE} /> : <PolicyInfoList items={data?.context?.contents ?? []} />;
    $[12] = data?.context?.contents;
    $[13] = isLoading;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== meta || $[16] !== onPageChange || $[17] !== page || $[18] !== t7) {
    t8 = <SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange}>{t7}</SearchSectionShell>;
    $[15] = meta;
    $[16] = onPageChange;
    $[17] = page;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t8) {
    t9 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t5} rightAside={t6}>{t8}</DesktopPageShell>;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}